// pages/ReportData.js

import AdminHeader from "../components/AdminHomeScreen/AdminHeader";
import AdminReportData from "../components/AdminMenuScreen/AdminReportData";
import AdminFooter from "../components/AdminHomeScreen/AdminFooter";

const AdminReport = () => {
  return (
    <>
      <AdminHeader />
      <AdminReportData />
      <AdminFooter />
    </>
  );
}

export default AdminReport;